export default fields => {
    return values => {
        let errors = {};
        const doesMatchState = (conditionKey, conditionValue) => {
            return values[conditionKey] === conditionValue;
        };
        //Loop through fields in schema

        fields.map(field => {
            let applicable = true; //By default, we assume validation is applicable

            //1. Check if stateCondiations exist before proceeding with the current validation
            if ('stateConditions' in field) {
                applicable = false; //Since conditions are present, let's ensure they are all met
                let conditions = field['stateConditions'];

                //Loop through each stateCondition
                Object.keys(conditions).map(condKey => {
                    if (Array.isArray(conditions[condKey])) {
                        //If any of the contents of the array are true, this particular condition is met
                        for (var val of conditions[condKey]) {
                            if (doesMatchState(condKey, val) === true) {
                                applicable = true;
                                break;
                            }
                        }
                    } else {
                        //If condition is met, applicable will be set to true
                        applicable = doesMatchState(condKey, conditions[condKey]);
                    }
                    return true;
                });
            }
            if (!applicable) return false;

            if ('required' in field) {
                if (!values[field.name]) {
                    errors[field.name] = field.error || `Invalid ${field.name} entered`;
                } else if ('validator' in field) {
                    //Retrieve relevant regEx
                    //Test value against regEx
                    let validator = field.validator;
                    if (validator.regEx.test(values[field.name]) === false) {
                        errors[field.name] = values[field.name].error || `Invalid ${field.name} entered`;
                    } else {
                        delete errors[field.name];
                    }
                } else {
                    delete errors[field.name];
                }
            }
            return true;
        });

        return errors;
    };
};
